import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import { getActionCompletedTime } from '../../utils/actionTiming';

const eventMappings = {};
eventMappings[actions.QUIZ_SUCCESS] = [trackCompleteAction];

export default function trackQuiz(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

const getQuizAnsweredText = state => {
    const action = state.widget.actions.find(
        a => a.identifier === state.quiz.lastAnsweredQuiz.actionIdentifier
    );

    return action.possibleAnswers.find(a => a.id === state.quiz.lastAnsweredQuiz.answerId)
        .text;
};

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        amount: state.donation.selectedAmount,
        actionCompleteTime: getActionCompletedTime(state, 'quiz')(),
        answerText: getQuizAnsweredText(state)
    });
}



// WEBPACK FOOTER //
// ./src/containers/Quiz/tracking.js